<lync-common-sidebar [title]="'ship_interface.vessel_reports'" [menuData]="menuData()" [enableNavigating]="true" />
